import { helper } from '@ember/component/helper';

import { minDate, maxDate } from 'rise-ui/config/time-series/query-params.js';

export default helper(function isMinMaxDate([ date ]) {
  return date === minDate || date === maxDate;
});
